function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import renderIf from '@signal/utils/renderIf';
import Tooltip from '../Tooltip';
import { Wrapper, Section, Metric, Label } from './styles';
export var DataGrid = function DataGrid(_ref) {
  var items = _ref.items,
      sectionProps = _ref.SectionProps,
      metricProps = _ref.MetricProps,
      labelProps = _ref.LabelProps,
      TooltipComponent = _ref.tooltipComponent,
      rest = _objectWithoutProperties(_ref, ["items", "SectionProps", "MetricProps", "LabelProps", "tooltipComponent"]);

  return /*#__PURE__*/React.createElement(Wrapper, rest, items.map(function (_ref2) {
    var label = _ref2.label,
        metric = _ref2.metric,
        tooltip = _ref2.tooltip;
    return /*#__PURE__*/React.createElement(Section, Object.assign({
      key: label
    }, sectionProps), /*#__PURE__*/React.createElement(Metric, metricProps, metric), /*#__PURE__*/React.createElement(Label, labelProps, renderIf(tooltip, function () {
      return /*#__PURE__*/React.createElement(TooltipComponent, Object.assign({}, tooltip, {
        target: label
      }));
    }, label)));
  }));
};
DataGrid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    metric: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  SectionProps: PropTypes.object,
  MetricProps: PropTypes.object,
  LabelProps: PropTypes.object
};
DataGrid.defaultProps = {
  items: [],
  tooltipComponent: Tooltip
};
export default DataGrid;